import AsszociaciosKerdesTableService from 'app/admin/asszociacioskerdes/service/AsszociaciosKerdesTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import TableQuestionViewButton from 'app/admin/kerdes/component/TableQuestionViewButton';
import AsszociaciosLeirasService from '../service/AsszociaciosLeirasService';

const config = {
	key: 'asszociaciosKerdesTable',
	text: 'Asszociációs kérdés',
	textKey: 'associationquestion',
	service: AsszociaciosKerdesTableService,
	icon: 'person',
	editFormState: item => `/asszociacioskerdes/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'refresh', 'new'],
	filterFields: [
		{
			propertyName: 'csorszam',
			propertyType: 'String',
			type: 'LIKE'
		},
		{
			propertyName: 'feladatCsoport',
			propertyType: 'Long',
			type: 'IN'
		}
	],
	rowButtonList: [
		{
			key: 'questionView',
			component: TableQuestionViewButton,
			service: AsszociaciosLeirasService
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		/*{
			key: 'sorszamTol',
			text: 'Sorszám tól',
			textKey: 'sorszamTol',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'sorszamIg',
			text: 'Sorszám ig',
			textKey: 'sorszamIg',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
        {
            key: 'alsorszamTol',
            text: 'Alsorszám tól',
            textKey: 'alsorszamTol',
            type: 'text',
            sortable: true,
            disablePadding: false
        },
        {
            key: 'alsorszamIg',
            text: 'Alsorszám ig',
            textKey: 'alsorszamIg',
            type: 'text',
            sortable: true,
            disablePadding: false
        },
        {
            key: 'subsorszamTol',
            text: 'Subsorszam tól',
            textKey: 'subsorszamTol',
            type: 'text',
            sortable: true,
            disablePadding: false
        },
        {
            key: 'subsorszamIg',
            text: 'Subsorszam ig',
            textKey: 'subsorszamIg',
            type: 'text',
            sortable: true,
            disablePadding: false
        },*/
		{
			key: 'csorszam',
			text: 'Sorszám',
			textKey: 'csorszam',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'aktiv',
			text: 'Aktív',
			textKey: 'aktiv',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'leirasPlaintext',
			text: 'Leírás',
			textKey: 'leirasPlaintext',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'feladatCsoport',
			text: 'Feladatcsoport',
			textKey: 'feladatCsoport',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function AsszociaciosKerdesTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('asszociaciosKerdesTable', reducer('asszociaciosKerdesTable'))(AsszociaciosKerdesTable);
